import {
  PaymentMethodValues,
  paymentTypeMap,
} from '../../../pages/shopping-basket/cash-payment/utils/helpers';
import {CreditPaymentResponse} from '../../../pages/shopping-basket/cash-payment/utils/types';
import request from '../../axios';

export const getOrderCreditTransactionPrice = async (
  orderGuid?: string,
  paymentType?: PaymentMethodValues,
) => {
  const {data}: {data: CreditPaymentResponse} = await request.get(
    `/api/v2/payment/calculate-order-price`,
    {
      params: {
        order: orderGuid,
        payment_type: paymentType ? paymentTypeMap[paymentType] : undefined,
      },
    },
  );

  return data;
};
